export type RootPageContext = {
	screenSize: ScreenSize | null
};

export enum ScreenSize {
	Small = 'Small',
	Tablet = 'Tablet',
	PortraitTablet = 'PortraitTablet',
}

